import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { MainBuscarFilterComponent } from './main-buscar-filter/main-buscar-filter.component';



@NgModule({
  declarations: [MainBuscarFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
  ],
  exports: [MainBuscarFilterComponent]
})
export class BuscarFilterModule { }
